import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PrivateAxios } from '../request/axios';
import Loading from '../components/loading/Loading'
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import AccessMatrix from './AccessMatrix';


const PrivateRoutes = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {

    const verifyUser = async () => {
      try {
        const response = await PrivateAxios.get('/user/is-logged-in', {
          withCredentials: true,
        });
        if (response.status !== 200) {
          setIsAuthenticated(false);
          return;
        }
      } catch (error) {
        setIsAuthenticated(false);
        return;
      }


      const token = localStorage.getItem('assistance-axa-token');
      if (token === null || !token) {
        setIsAuthenticated(false);
        return navigate('/logout', { state: { message: 'Merci de vous connecter.' } });

      }
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        setIsAuthenticated(false);
        return navigate('/logout', { state: { message: 'Votre session a expiré. Veuillez vous reconnecter.' } });
      }

      const userRoles = decoded.roles || [];

      // Vérification des droits
      const currentPath = location.pathname;

      // Si le chemin existe dans la matrice des accès, on vérifie les rôles
      if (AccessMatrix[currentPath]) {
        const requiredRoles = AccessMatrix[currentPath];
        const hasAccess = requiredRoles.some((role) => userRoles.includes(role));

        if (!hasAccess) {
          return navigate('/unauthorized', { state: { message: "Vous n'avez pas l'autorisation d'accéder à cette page." } });
        }
      }

      setIsAuthenticated(true);
    };

    verifyUser();
  }, [location, navigate]);

  if (isAuthenticated === null) {
    return <div className='h-screen'><Loading /></div>
  }

  return isAuthenticated ? children : <Navigate to="/login" replace={true} />;
};

export default PrivateRoutes;